import React from 'react';
import PropTypes from 'prop-types';

const SimpleText = ({ content }) => (<span>{content}</span>);

SimpleText.propTypes = {
  content: PropTypes.oneOfType([PropTypes.instanceOf(Array)]).isRequired,
};

export default SimpleText;
